import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Plus, Heart } from "lucide-react";
import { formatBRL } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { useWishlist } from "@/context/WishlistContext";

export default function ProductCard({ product, index = 0 }) {
  const { addItem } = useCart();
  const { has, toggle } = useWishlist();
  const img = product.images?.[0];
  const hoverImg = product.images?.[1] || img;
  const fav = has(product.id);

  const quickAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const size = product.sizes?.[0] || null;
    const color = product.colors?.[0] || null;
    addItem(product, { size, color, quantity: 1 });
    toast.success(`${product.name} adicionado à sacola`);
  };

  const onFav = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggle(product);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, ease: [0.25, 1, 0.5, 1], delay: (index % 4) * 0.08 }}
    >
      <Link to={`/produto/${product.id}`} data-testid={`product-card-${product.id}`} className="group block">
        <div className="relative overflow-hidden bg-[#EFEEEA] aspect-[3/4] mb-4">
          <img src={img} alt={product.name}
            className="absolute inset-0 w-full h-full object-cover transition-opacity duration-[600ms] ease-out group-hover:opacity-0" />
          <img src={hoverImg} alt={product.name}
            className="absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-[600ms] ease-out group-hover:opacity-100" />
          {product.featured && (
            <span className="absolute top-4 left-4 bg-[#F8F7F4] text-[#1A1A1A] text-[9px] uppercase tracking-[0.2em] px-3 py-1.5">Destaque</span>
          )}
          <button data-testid={`wishlist-${product.id}`} onClick={onFav} aria-label="Favoritar"
            className="absolute top-3.5 right-3.5 w-9 h-9 flex items-center justify-center bg-[#F8F7F4]/85 backdrop-blur-sm hover:bg-[#F8F7F4] transition-colors">
            <Heart size={16} strokeWidth={1.5} className={fav ? "fill-[#B89C65] text-[#B89C65]" : "text-[#1A1A1A]"} />
          </button>
          <button data-testid={`quick-add-${product.id}`} onClick={quickAdd}
            className="absolute left-4 right-4 bottom-4 bg-[#1A1A1A]/95 text-[#F8F7F4] py-3.5 text-[11px] uppercase tracking-[0.15em] flex items-center justify-center gap-2 translate-y-[calc(100%+1.5rem)] group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-500 ease-out hover:bg-[#B89C65]">
            <Plus size={14} /> Adição rápida
          </button>
        </div>
        <div className="text-[10px] uppercase tracking-[0.2em] text-[#5C5B59] mb-1.5">{product.category}</div>
        <h3 className="font-serif text-xl leading-tight text-[#1A1A1A] group-hover:text-[#B89C65] transition-colors">{product.name}</h3>
        <p className="mt-1.5 text-xs tracking-[0.1em] text-[#1A1A1A]">{formatBRL(product.price)}</p>
      </Link>
    </motion.div>
  );
}
